import setMuseumId from '../../hooks/setMuseumId'
import processFiles from '../../hooks/processFiles'

export default {
  before: {
    all: [],
    find: [],
    get: [],
    create: [setMuseumId(), processFiles()],
    update: [processFiles()],
    patch: [processFiles()],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
}



// WEBPACK FOOTER //
// ./src/services/author/author.hooks.js